import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Gallery from "./Gallery/Gallery";
import FileFolderSearch from "./Components/FileFolderSearch";
import GalleryEdit from "./Gallery/GalleryEdit";

const AppRouter = () => {
  // alert(window.location.href)
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="/gallery/:folderId" element={<Gallery />} />
      <Route exact path="/gallery/edit/:folderId" element={<GalleryEdit />} />
      {/* <Route exact path="/search/:term" element={<FileFolderSearch />} /> */}
      <Route exact
        path="/search/:startDate/:endDate"
        element={<FileFolderSearch />}
      />
      <Route exact
        path="/search/:term?/:startDate?/:endDate?"
        element={<FileFolderSearch />}
      />
    
        <Route exact path="/:folderId" element={<Gallery />} />
    </Routes>
  );
};

export default AppRouter;
